import { render, staticRenderFns } from "./GasHistory.vue?vue&type=template&id=164b8c5e"
import script from "./GasHistory.vue?vue&type=script&lang=js"
export * from "./GasHistory.vue?vue&type=script&lang=js"
import style0 from "./GasHistory.vue?vue&type=style&index=0&id=164b8c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports